import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { EMPTY, Observable, Subject } from 'rxjs';
import { Tile } from '../../widgets/tile/tile.component';
import { BaseService } from '../../../../services/framework/base.service';
import { ModalOptions, displayModalComponent } from '../../widgets/models';
import { WhiteboardViewComponent } from '../components/whiteboard-view/whiteboard-view.component';
import { WhiteboardAddComponent } from '../components/whiteboard-add/whiteboard-add.component';
import { ServiceItem } from '../../../../services/framework/serviceitem';

@Injectable({
  providedIn: 'root'
})
export class MiroService extends BaseService<MiroBoard>{
  
  private emitChangeSource = new Subject<any>();

  changeEmitted$ = this.emitChangeSource.asObservable();
 
  constructor(public http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any, private modalService: NgbModal) {
    super(http, auth);
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.getEndpoint = 'miro/';
    this.apiKey = configSettings['apiKey'];
  }

  async ngOnInit() {

  }

  refresh() {
    this.emitChangeSource.next();
  }

  public getMiroBoardsForUser(useremail: string) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "GetMiroBoardsForUser?userEmail=" + useremail;
    if (token != undefined) {
      return this.http.get<MiroBoard[]>(url, this.getHttpOptions(token));     
    }
    else {
      return EMPTY;
    }
  }

  createNewBoard(request: MiroNewBoard): Promise<MiroNewBoard> {
    const url = this.apiUrl + this.getEndpoint + "CreateNewBoard";
    const boardId = this.postSingleItem<MiroNewBoard>(url, request ,).toPromise()
      .then(res => {       
        return res;
      });
    return boardId;
  }
 
  private postSingleItem<T>(url: string, content: any): Observable<T> {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.post<T>(url, content, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  showMiroBoard(boardId: string) {
    let params: any[] = [];

    let options: ModalOptions = {
      title: 'Miro Whiteboard',
      showSave: false,
      showCancel: true,
      showCross: true,
      showFullscreen: true
    };

    params.push(boardId);
    
    displayModalComponent(WhiteboardViewComponent, 'xl', options, this.modalService, params);
  }

  addMiroBoard(params: any[]) {
    let options: ModalOptions = {
      title: 'Add New Whiteboard',
      showSave: true,
      showCancel: true,
      showCross: false,
    };

    displayModalComponent(WhiteboardAddComponent, 'lg', options, this.modalService, params);
  }

  public getLinkedBoards(id: string){
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "LinkedBoards/" + id;
    if (token != undefined) {
      return this.http.get<IWorkspaceWhiteboard[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  public getAvailableBoards(id: string) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "AvailableBoards/" + id;
    if (token != undefined) {
      return this.http.get<IWorkspaceWhiteboard[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }
 
  public unLinkWorkspaceWhiteBoard(id: string) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "UnLinkBoard/" + id;
    if (token != undefined) {
      return this.http.get<boolean>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  public linkWorkspaceWhiteBoard(id: string, boardId: any) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "LinkBoard/" + boardId + "/" + id;
    if (token != undefined) {
      return this.http.get<boolean>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }
  
}

export interface MiroBoard extends ServiceItem {
  name: string;
  description: string;
  owner: string;
  imageUrl: string;
  tile: Tile;
  miroId: string;
}

export interface MiroNewBoard extends ServiceItem{
  owner: string;
  name: string;
  description: string;
  emailAddresses: string[];
}


export interface IWorkspaceWhiteboard extends ServiceItem {
  workspaceId: string;
  boardName: string;
  description: string;
  owner: string;
}

//function displayModalComponent(WhiteboardViewComponent: typeof WhiteboardViewComponent, arg1: string, options: ModalOptions, modalService: NgbModal, params: any[]) {
//    throw new Error('Function not implemented.');
//}
